export const firebaseConfig = {
  apiKey: "AIzaSyBiTuo9Vcu7Xm4GM9SmKM0YcV2JaHy7byY",
  authDomain: "diplo-magic.firebaseapp.com",
  databaseURL: "https://diplo-magic-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "diplo-magic",
  storageBucket: "diplo-magic.appspot.com",
  messagingSenderId: "381032893112",
  appId: "1:381032893112:web:520b9c69108352952c024d",
  measurementId: "G-6130ZJL3GT"
};